/**
 * Utility functions for handling image paths
 */

// Base API URL from environment variable or default to localhost
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * Get the full image URL from a relative path
 * @param path - Relative image path (e.g., /uploads/products/image.jpg)
 * @returns Full image URL
 */
export const getImageUrl = (path: string | null | undefined): string => {
  // For debugging only
  // console.log('Original image path:', path);
  
  if (!path) {
    // Use local placeholder image instead of external service
    const baseUrl = API_BASE_URL.includes('/api') 
      ? API_BASE_URL.split('/api')[0] 
      : API_BASE_URL;
    return `${baseUrl}/uploads/placeholder.svg`;
  }
  
  // Handle empty strings
  if (path.trim() === '') {
    // Use local placeholder image instead of external service
    const baseUrl = API_BASE_URL.includes('/api') 
      ? API_BASE_URL.split('/api')[0] 
      : API_BASE_URL;
    return `${baseUrl}/uploads/placeholder.svg`;
  }
  
  // If the path is already a full URL (starts with http:// or https://)
  if (path.startsWith('http://') || path.startsWith('https://')) {
    // Replace localhost URLs with production URLs in production environment
    if (path.includes('localhost:5000') && API_BASE_URL !== 'http://localhost:5000') {
      // Use the API_BASE_URL from environment variables, removing any /api suffix
      const productionBaseUrl = API_BASE_URL.includes('/api') 
        ? API_BASE_URL.split('/api')[0] 
        : API_BASE_URL;
      return path.replace('http://localhost:5000', productionBaseUrl);
    }
    return path;
  }
  
  // Ensure path starts with a slash if it doesn't already
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  // Special handling for uploads - don't add /api prefix
  if (normalizedPath.startsWith('/uploads/')) {
    // For uploads, we want to use the domain root, not the API path
    const baseUrl = API_BASE_URL.includes('/api') 
      ? API_BASE_URL.split('/api')[0] 
      : API_BASE_URL;
    return `${baseUrl}${normalizedPath}`;
  }
  
  // For other API paths
  return `${API_BASE_URL}${normalizedPath}`;
};
